// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"473f0e3e","118":"b6ba17de","233":"30c55af4","246":"03e67486","341":"c0402735","447":"91f67103","896":"598c7672"}[chunkId] + ".chunk.js";
};